import './App.css';
import Error from './Page/Error';
import Coupons from './Page/Coupons';
import Homepage from './Page/Homepage';
import PrivacyPolicy from './Page/PrivacyPolicy';
import GymXpPrivacyPolicy from './Page/GymXpPrivacyPolicy';
import EULA from './Page/EULA';
import { BrowserRouter, Routes, Route} from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <div className="App">
          <Routes>
            <Route path='/' element={<Homepage />} />
            <Route path='/referAFriend/:couponId' element={<Coupons />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/GymXp/privacy-policy' element={<GymXpPrivacyPolicy />} />
            <Route path='/eula' element={<EULA />} />
            <Route path='*' element={<Error />} />
          </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
